import { useState, useEffect, useRef } from "react";
import "./App.css";
import "./styles/nobelly.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import AgeGate from "./components/AgeGate";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileStickyCta from "./components/MobileStickyCta";
import CookieConsent from "./components/CookieConsent";
import Home from "./pages/Home";
import Legal, { PrivacyPolicy, TermsOfUse, ResponsibleDrinking } from "./pages/Legal";
import OurBeer from "./pages/OurBeer";
import FindUs from "./pages/FindUs";
import OurStory from "./pages/OurStory";
import Events from "./pages/Events";
import Horeca from "./pages/Horeca";
import { pushPageView } from "./utils/analytics";

// Restores viewport to the top on every route change. Uses instant scroll
// (behavior 'auto') to avoid the slow long-distance browser smooth-scroll.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);
  return null;
}

// SPA page-view tracker. Skips the initial load (handled by GTM's Google
// Tag automatically) and fires exactly one virtual_page_view per genuine
// client-side route change. Deferred slightly so usePageMeta has time to
// update document.title before we read it.
function PageViewTracker() {
  const location = useLocation();
  const isFirst = useRef(true);
  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    const t = setTimeout(() => {
      pushPageView({ path: location.pathname + location.search });
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  const [ageVerified, setAgeVerified] = useState(false);

  return (
    <div className="App">
      <BrowserRouter>
        {!ageVerified ? (
          <AgeGate onVerified={() => setAgeVerified(true)} />
        ) : (
          <>
            <ScrollToTop />
            <PageViewTracker />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/our-beer" element={<OurBeer />} />
              <Route path="/find-us" element={<FindUs />} />
              <Route path="/our-story" element={<OurStory />} />
              <Route path="/events" element={<Events />} />
              <Route path="/horeca" element={<Horeca />} />
              {/* Legacy — trade page moved to /horeca */}
              <Route path="/for-trade" element={<Navigate to="/horeca" replace />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfUse />} />
              <Route path="/responsible-drinking" element={<ResponsibleDrinking />} />
            </Routes>
            <MobileStickyCta />
            <Footer />
            <CookieConsent />
          </>
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;
